import { Checkbox } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import { LibraryAPI, TicketsAPI } from "api";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import CardDropdown from "components/common/CardDropdown";
import IconButton from "components/common/IconButton";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { Card, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdDeleteOutline, MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import "./styles.css";
import {
  clearLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from "./utils/StoreState";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import TicketPrint from "modules/reporting/TicketPrint/TicketPrint";

export default function TicketsTable() {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const columnApiRef = useRef();
  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const printRef = useRef();
  const [printTicket, setPrintTicket] = useState(null);

  const handlePrintTicket = (data) => {
    setPrintTicket(data);

    setTimeout(() => {
      printRef.current.handlePrint();
    }, 200);
  };

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([
    // { field: "", filter: false, headerName: "Select" },

    {
      field: "ticketNumber",
      headerName: "Ticket Number",
      filter: false,
      hide: false,
    },
    {
      field: "patientName",
      headerName: "Patient Name",
      filter: false,
      hide: false,
    },

    {
      field: "ticketDate",
      headerName: "Date",
      hide: false,
      filter: false,
      cellRenderer: (p) => {
        const date = p?.data?.ticketDate
          ? new Date(p.data?.ticketDate).toLocaleDateString()
          : "";
        return <div>{date}</div>;
      },
    },
    {
      field: "amountPaid",
      headerName: "Amount Paid",
      filter: false,
      hide: false,
    },
    { field: "status", headerName: "Status", hide: false, filter: false },
    // {
    //   field: "active",
    //   headerName: "Active",
    //   filter: false,
    //   hide: false,
    //   cellStyle: {
    //     display: "flex",
    //     paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => <Checkbox checked={p?.data.active} />,
    // },
    {
      headerName: "Action",
      field: "action",
      maxWidth: 120,
      filter: false,
      // cellStyle: {
      //   display: "flex",
      //   justifyContent: "center",
      //   alignItems: "center",
      // },
      cellRenderer: (p) => (
        <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              // as={Link}
              onClick={() =>
                // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
                // () =>
                handleRowClick(p.data)
              }
              // href="/products/add-product"
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdOutlineModeEdit />
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handlePrintTicket(p.data)}
              className="d-flex align-items-center gap-2 py-0"
            >
              🖨 Print Ticket
            </Dropdown.Item>
            {/* <Dropdown.Item
              onClick={() => handleDelete(p.data)}
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdDeleteOutline />
              Delete
            </Dropdown.Item> */}
          </div>
        </CardDropdown>
      ),
    },
  ]);

  const handleRowClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_TICKET, { state: data });
    }
  };

  const getData = async () => {
    const response = await TicketsAPI.get();
    return response?.data?.data;
  };

  const handleDelete = async (info) => {
    try {
      await LibraryAPI.delete(info.id);
      toast.success("Record Deleted Successfully", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      const newData = await getData();
      gridApi.setGridOption("rowData", newData);
    } catch (error) {
      console.log(error);
      toast.error("Something went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    // floatingFilter: true,
    flex: 1,
    // rowDrag: true,
  };

  const rowStyle = { cursor: "pointer" };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  const onGridReady = useCallback(
    async (e) => {
      gridApi = e.api;
      columnApi = e.columnApi;
      restoreState();
      // LibraryAPI.get({ params: { library: 1 } }).then((res) => {
      //   e.api.applyTransaction({ add: res?.data?.data });
      // });

      const data = await getData();
      e.api.applyTransaction({ add: data });
    },
    [window],
  );

  const saveState = useCallback(() => {
    const colState = columnApiRef.current.api.getColumnState();
    setLocalStorage(colState);
    console.log("column state saved");
  }, []);

  const restoreState = useCallback(() => {
    const colState = getLocalStorage();
    if (!colState) {
      console.log("no columns state to restore by, you must save state first");
      return;
    }
    columnApiRef.current.api.applyColumnState({
      state: colState,
      applyOrder: true,
    });
    console.log("column state restored");
  }, []);

  const resetState = useCallback(() => {
    columnApiRef.current.api.resetColumnState();
    clearLocalStorage();
    console.log("column state reset");
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value,
    );
  }, []);

  // useEffect(() => {
  //   let isDarkBool = localStorage.getItem("isDark") === true;
  //   let isDarkTheme = localStorage.getItem("theme") === "dark";
  //   let auto = localStorage.getItem("theme") === "auto";

  //   if (isDarkBool || isDarkTheme || auto) {
  //     setTheme("ag-theme-quartz-dark");
  //   } else {
  //     setTheme("ag-theme-quartz");
  //   }
  // }, [localStorage.getItem("isDark") || localStorage.getItem("theme")]);

  // console.log(theme);

  return (
    <div>
      <div className="py-2">
        <BreadCrumb />
      </div>

      <div
        className={`${
          isDarkBool || isDarkTheme || auto
            ? "ag-theme-quartz-dark"
            : "ag-theme-quartz"
        } rounded-0`} // applying the grid theme
        style={{ height: "100vh" }} // the grid will fill the size of the parent container
      >
        <Card className="h-100">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Tickets</h5>
            <div className="d-flex gap-2">
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    New
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() => navigate(CONSTANT_ROUTES.ADD_NEW_TICKET)}
                >
                  <span className="d-none d-sm-inline-block ms-1">New</span>
                </IconButton>
              </OverlayTrigger>
              <TableHeaderDropdown>
                <div className="py-2">
                  <Dropdown.Item
                    onClick={saveState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Save State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={restoreState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Restore State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={resetState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Reset State
                  </Dropdown.Item>
                </div>
              </TableHeaderDropdown>
            </div>
            {/* <div className="test-header">
              <div className="example-header">
                <input
                  type="text"
                  id="filter-text-box"
                  placeholder="Search"
                  onInput={onFilterTextBoxChanged}
                />
              </div>
              <div className="example-section">
                <button onClick={saveState}>Save State</button>
                <button onClick={restoreState}>Restore State</button>
                <button onClick={resetState}>Reset State</button>
              </div>
            </div> */}
          </Card.Header>

          <Card.Body className="p-0">
            {/* <button onClick={() => onExportClick()}>abc</button> */}

            <AgGridReact
              // rowData={rowData}
              ref={columnApiRef}
              onGridReady={onGridReady}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              rowStyle={{ cursor: "pointer" }}
              // pagination={true}
              onRowDoubleClicked={(params) => handleRowClick(params.data)}
              overlayNoRowsTemplate="Nothing found - Looks empty over here"
            />
          </Card.Body>
        </Card>
      </div>

      <div style={{ display: "none" }}>
        <TicketPrint ref={printRef} ticket={printTicket} />
      </div>
    </div>
  );
}
